import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    permitsAndQuestionnairesByForeigner: [],
  },
  mutations: {
    set,
  },
  actions: {
    async loadOverview({ commit }) {
      const family = await this.$axios.$get('/api_foreigner/family/');
      const wholeFamilyQuestionnaires = await this.$axios.$get('/api_foreigner/survey/');
      const wholeFamilyPermits = await this.$axios.$get('/api_foreigner/permit/?page=1&page_size=200');
      const combinedData = family.map((familyMember) => {
        const questionnaires = wholeFamilyQuestionnaires.filter((questionnaire) => questionnaire.foreigner_id === familyMember.id && !questionnaire.submitted);
        const permits = wholeFamilyPermits.filter((permit) => permit.foreigner_id === familyMember.id && permit.permit_status !== 30);

        const someDocumentsAreMissing = permits.some((permit) => permit.permit_document_missing_count > 0);
        const someQuestionnairesAreNotSubmitted = questionnaires.length > 0;

        return {
          id: familyMember.id,
          name: familyMember.fullname,
          avatar_url: familyMember.avatar_url,
          questionnaires,
          permits,
          isShowBadge: someDocumentsAreMissing || someQuestionnairesAreNotSubmitted,
        };
      });

      commit('set', ['permitsAndQuestionnairesByForeigner', combinedData]);
    },
  },
};
